import { methods, ServiceMaker } from './index';

const { POST , GET } = methods;

export const quickpay = data => ServiceMaker(`/v1/api/pg/order/request/quickpay`, POST, null, data);

export const getStatus = async id => ServiceMaker(`/v1/api/pg/order/status/${id}`, GET);

export const easebuzzGetStatus = async id => ServiceMaker(`/v1/api/payments/easebuzz/status/${id}`, GET);